"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpUpload = void 0;
var index_1 = require("../index");
var helpers_1 = require("../helpers/helpers");
var messages_1 = require("../constants/messages");
var core_1 = require("./core");
var v2_1 = require("./v2");
/**
 * HTTP Gateway Upload Logic
 *
 * @param transferSpec - TransferSpec for the upload
 * @param asperaSdkSpec IBM Aspera settings when starting a transfer.
 *
 * @returns Promise that resolves on success invoke or rejects if unable to start
 *
 * @remarks
 * Most logic is called directly by Desktop SDK functions
 * You may not need to import anything from this file.
 */
var httpUpload = function (transferSpec, asperaSdkSpec) {
    if (!index_1.asperaSdk.httpGatewayIsReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified, { type: 'upload' });
    }
    if (index_1.asperaSdk.useOldHttpGateway) {
        return (0, v2_1.upload)(transferSpec, (asperaSdkSpec === null || asperaSdkSpec === void 0 ? void 0 : asperaSdkSpec.http_gateway_v2_transfer_id) || '');
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var request = new XMLHttpRequest();
    var body = new FormData();
    body.append('x-aspera-spec', (0, helpers_1.safeJsonString)(transferSpec));
    var hasBadFile = [];
    transferSpec.paths.forEach(function (path) {
        var foundFile = index_1.asperaSdk.httpGatewaySelectedFiles.get(path.source);
        if (foundFile) {
            body.append('Content-Length', String(foundFile.size));
            body.append('file', foundFile);
        }
        else {
            hasBadFile.push(path.source);
        }
    });
    if (hasBadFile.length) {
        return (0, helpers_1.throwError)(messages_1.messages.fileNotAllowed, { type: 'upload', invalidFiles: hasBadFile, transferSpec: transferSpec });
    }
    var transferObject = (0, core_1.getSdkTransfer)(transferSpec);
    index_1.asperaSdk.httpGatewayRequestStore.set(transferObject.uuid, request);
    if (asperaSdkSpec === null || asperaSdkSpec === void 0 ? void 0 : asperaSdkSpec.http_gateway_authentication) {
        request.setRequestHeader('Authorization', "Bearer ".concat(asperaSdkSpec.http_gateway_authentication.token));
        request.setRequestHeader('X-Aspera-AccessKey', asperaSdkSpec.http_gateway_authentication.access_key);
    }
    request.open('POST', "".concat((asperaSdkSpec === null || asperaSdkSpec === void 0 ? void 0 : asperaSdkSpec.http_gateway_override_server_url) || index_1.asperaSdk.globals.httpGatewayUrl).concat(index_1.asperaSdk.globals.httpGatewayRoutePrefix, "/upload"), true);
    var triggerUpdate = function () {
        (0, core_1.sendTransferUpdate)(transferObject);
    };
    var triggerFailed = function () {
        if (transferObject.status === 'cancelled') {
            return;
        }
        var errorData = (0, core_1.getMessageFromError)(request.response);
        transferObject.httpRequestId = request.getResponseHeader('X-Request-Id');
        transferObject.status = 'failed';
        transferObject.error_code = errorData.code;
        transferObject.error_desc = errorData.message;
        index_1.asperaSdk.httpGatewayRequestStore.delete(transferObject.uuid);
        triggerUpdate();
    };
    request.upload.addEventListener('progress', function (event) {
        if (transferObject.status === 'failed') {
            return;
        }
        transferObject.status = 'running';
        transferObject.elapsed_usec = (new Date().getTime() - new Date(transferObject.add_time).getTime()) * 1000;
        if (event.lengthComputable) {
            transferObject.bytes_expected = event.total;
            transferObject.bytes_written = event.loaded;
            transferObject.percentage = (event.loaded / event.total);
        }
        triggerUpdate();
    });
    request.addEventListener('load', function () {
        transferObject.httpRequestId = request.getResponseHeader('X-Request-Id');
    });
    request.upload.addEventListener('load', function (event) {
        if (transferObject.status === 'failed') {
            return;
        }
        transferObject.status = 'completed';
        transferObject.elapsed_usec = (new Date().getTime() - new Date(transferObject.add_time).getTime()) * 1000;
        if (event.lengthComputable) {
            transferObject.bytes_expected = event.total;
            transferObject.bytes_written = event.loaded;
            transferObject.percentage = (event.loaded / event.total);
        }
        index_1.asperaSdk.httpGatewayRequestStore.delete(transferObject.uuid);
        triggerUpdate();
    });
    request.upload.addEventListener('loadstart', function () {
        if (transferObject.status === 'failed') {
            return;
        }
        transferObject.status = 'running';
        promiseInfo.resolver(transferObject);
        triggerUpdate();
    });
    request.addEventListener('readystatechange', function () {
        if (request.status >= 400) {
            triggerFailed();
        }
    });
    request.upload.addEventListener('error', function (event) {
        triggerFailed();
        promiseInfo.rejecter(event);
    });
    request.upload.addEventListener('abort', function (event) {
        triggerFailed();
        promiseInfo.rejecter(event);
    });
    request.addEventListener('error', function (event) {
        triggerFailed();
        promiseInfo.rejecter(event);
    });
    request.addEventListener('abort', function (event) {
        triggerFailed();
        promiseInfo.rejecter(event);
    });
    request.send(body);
    return promiseInfo.promise;
};
exports.httpUpload = httpUpload;
